import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./style.css";
import Logo_header from "../img/logo/Logo_header.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FiHome, FiMail, FiInfo, FiUsers, FiLifeBuoy } from "react-icons/fi";

function NavbarComp() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Function to handle smooth scrolling with offset
  const handleScroll = (el) => {
    if (el) {
      let yOffset; 
      //alert(window.innerWidth);
      // if (window.innerWidth == 390) {
      //   //alert('window.innerWidth < 576');
      //   yOffset = -420; // Small mobile screens (phones)
      // } else if (window.innerWidth == 392) {
      //   //alert('window.innerWidth >= 576 && window.innerWidth < 992');
      //   yOffset = -100; // Tablets
      // } else if (window.innerWidth < 576) {
      //   //alert('window.innerWidth < 576');
      //   yOffset = -100; // Small mobile screens (phones)
      // } else if (window.innerWidth >= 576 && window.innerWidth < 992) {
      //   //alert('window.innerWidth >= 576 && window.innerWidth < 992');
      //   yOffset = -100; // Tablets
      // } else {
        //alert('else');
        yOffset = 50; // Desktops & larger screens
    //}
      const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleClick = (e, to) => {
    setTimeout(() => {
      window.location.hash = to.replace("/#", ""); // Maintain hash in URL
    }, 300);
    setOpen(false); // Close menu on mobile
  };
  

  return (
    <>
      <Navbar expand="lg" className="navbar fixed-top bg-light shadow" expanded={open}>
        <Container fluid>
          <Link to="/">
            <img src={Logo_header} alt="logo" className="header-logo" width={"80%"} />
          </Link>

          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setOpen(!open)} />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <HashLink className="nav-item-style" id="close-button" scroll={handleScroll}  spy="true" smooth={true} duration={500} to="/#Home" onClick={(e) => handleClick(e, "/#Home")}>
                <FiHome /> Home
              </HashLink>
              <HashLink className="nav-item-style" id="close-button" scroll={handleScroll}  spy="true" smooth={true} duration={500} to="/#About" onClick={(e) => handleClick(e, "/#About")}>
                <FiInfo /> About
              </HashLink>
              <HashLink className="nav-item-style" id="close-button" scroll={handleScroll}  spy="true" smooth={true} duration={500} to="/#Team" onClick={(e) => handleClick(e, "/#Team")}>
                <FiUsers /> Team
              </HashLink>
              {/* <Link className="nav-item-style" id="close-button" scroll={handleScroll}  spy="true" smooth={true} duration={500} to="/products" onClick={() => setOpen(false)}>
                <FiLifeBuoy /> Product
              </Link> */}
              <HashLink className="nav-item-style" id="close-button" scroll={handleScroll}  spy="true" smooth={true} duration={500} to="/#Contact" onClick={(e) => handleClick(e, "/#Contact")}>
                <FiMail /> Contact
              </HashLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavbarComp;
